import { createSlice } from '@reduxjs/toolkit';

import initialState, * as handlers from './handlers';

const interviewForSession = createSlice({
  name: 'interviewForSession',
  initialState,
  reducers: {
    setInterviewForSession: handlers.setInterviewForSession,
  },
});

export const { actions, reducer } = interviewForSession;

export const { setInterviewForSession } = actions;

export default reducer;
